import { c as _c } from "react/compiler-runtime";
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { Dialog, DialogProps } from './Dialog.client';
import { box } from '@/uiPrimitives/layout/box';
import { sideOverlayModalCSS } from './SideOverlay.css';
export const SideOverlay = t0 => {
  const $ = _c(16);
  let children;
  let className;
  let classNameInner;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      classNameInner,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = classNameInner;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    classNameInner = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = classes(sideOverlayModalCSS, className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== classNameInner) {
    t2 = classes(box({
      minBlockSize: "100%"
    }), classNameInner);
    $[7] = classNameInner;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children || $[10] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[9] = children;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== props || $[13] !== t1 || $[14] !== t3) {
    t4 = <Dialog {...props} className={t1}>{t3}</Dialog>;
    $[12] = props;
    $[13] = t1;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};